export const EMAIL_FOR_SIGN_IN = 'emailForSignIn';
